import axios from "axios";
import store from "../store";

const axiosService = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosService.interceptors.request.use(
  function (c) {
    store.commit("SET_LOADING", true);
    return c;
  },
  function (e) {
    // En cas d'erreur
    store.commit("SET_LOADING", false);
    return Promise.reject(e);
  }
);

axiosService.interceptors.response.use(
  function (r) {
    // Si requête OK
    store.commit("SET_LOADING", false);
    return r;
  },
  function (e) {
    // En cas d'erreur
    store.commit("SET_LOADING", false);
    return Promise.reject(e);
  }
);

export default axiosService;
